<ion-header>
  <ion-toolbar>
    <ion-buttons class="pencil" slot="end">
      <ion-button color="primary" (click)="cancelar()">
        CANCELAR
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-searchbar placeholder="Pesquise pela Estação, Município ou Estado… " [formControl]="buscarInput" #searchbar></ion-searchbar>

  <!-- <ion-list class="lista-opcoes" lines="none" *ngIf="showMapFilter && !buscarInput.value">
    <ion-item (click)="localAtual()" class="cursor-pointer">
      <ion-icon slot="start" name="locate-outline"></ion-icon>
      <p>Usar minha localização</p>
    </ion-item>
    <ion-item (click)="selecionarNoMapa()" class="cursor-pointer">
     <ion-icon slot="start" name="mapa-pin"></ion-icon>
      <p>Selecionar no mapa</p>
    </ion-item>
  </ion-list> -->

  <ion-list class="lista-recentes" lines="none" *ngIf="!buscarInput.value && estacoesRecentes?.length">
    <ion-list-header>
      Recentes
    </ion-list-header>
    <ion-item *ngFor="let estacao of this.estacoesRecentes" (click)="estacaoDetalhe(estacao)" class="cursor-pointer">
      <ion-icon name="recente"></ion-icon>
      <p>{{estacao.noEstacao}}</p>
    </ion-item>
  </ion-list>


  <ion-item class="item-resultados">
    <ion-label>{{this.qtdResultados}} Resultados</ion-label>
    <ion-select placeholder="A-Z" [(ngModel)]="ordem" cancelText="Cancelar" okText="Confirmar">
      <ion-select-option value="0">A-Z</ion-select-option>
      <ion-select-option value="1">Z-A</ion-select-option>
    </ion-select>
  </ion-item>

  <empty-state [data]="estacoesFiltradas" emptyText="Não foi encontrada nenhuma estação de monitoramento de acordo com sua pesquisa"></empty-state>
  <ion-list class="lista-resultados" lines="none">
    <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
    <ion-item *ngFor="let estacao of estacoesFiltradas" (click)="estacaoDetalhe(estacao)" class="cursor-pointer">
      <ion-icon name="vento"  [ngClass]="'tipo-classificacao-' + estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.id"></ion-icon>
      <div class="wrapper-texto">
        <h1>{{estacao.noEstacao}}</h1>
        <p class="tipo-estacao" *ngIf="estacao.municipio">
          {{estacao.municipio?.noMunicipio}}/{{estacao.municipio?.uf.sgUf}}
        </p>
      </div>
    </ion-item>
  </ion-list>

</ion-content>
